import EmptyState from '../../../components/EmptyState/EmptyState';

const InvoiceContent = () => {
  return (
    <div className="flex flex-col gap-8">
      <EmptyState type="invoice" />
    </div>
  );
};

export default InvoiceContent;
